<template>
  <div id="time-picker-wrapper">
    <h5 class="time-picker-heading" v-if="heading">{{ heading }}</h5>
    <div id="pickers">
      <div class="hour-picker">
        <div class="scroll-container">
          <h5
            v-for="num in 12"
            :key="num"
            :class="{
              currentSelection: checkForHour(num),
            }"
            :id="'hour-' + num"
            @click="selectHour(num)"
          >
            {{ num }}
          </h5>
        </div>
      </div>
      <div class="minute-picker">
        <h5
          :class="{ currentSelection: checkForMinute((num - 1) * 15) }"
          v-for="num in 4"
          :key="num"
          @click="selectMinute((num - 1) * 15)"
        >
          {{ num === 1 ? "00" : (num - 1) * 15 }}
        </h5>
      </div>
      <div class="period-picker">
        <h5
          :class="{ currentSelection: checkForPeriod(val) }"
          v-for="val in ['AM', 'PM']"
          :key="val"
          @click="selectPeriod(val)"
        >
          {{ val }}
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      minuteOptions: ["00", "15", "30", "45"],
      hour: 3,
      minute: 30,
      period: "PM",
      time: undefined,
      initialized: false,
    };
  },
  computed: {},
  methods: {
    checkForHour(num) {
      return num === this.hour;
    },
    checkForMinute(num) {
      return num === this.minute;
    },
    checkForPeriod(val) {
      return val === this.period;
    },
    selectHour(num) {
      this.hour = num;
      this.save();
    },
    selectMinute(num) {
      this.minute = num;
      this.save();
    },
    selectPeriod(val) {
      this.period = val;
      this.save();
    },
    save() {
      if (this.initialized) {
        let time = new Date(this.initialValue);
        switch (this.period) {
          case "AM":
            if (this.hour === 12) {
              time.setHours(0);
            } else {
              time.setHours(this.hour);
            }
            time.setMinutes(this.minute);
            break;
          default:
            if (this.hour === 12) {
              time.setHours(12);
            } else {
              time.setHours(this.hour + 12);
            }
            time.setMinutes(this.minute);
            break;
        }
        this.$emit("input", time);
      }
    },

    initializeScroll() {
      setTimeout(() => {
        let element = document.getElementById("hour-" + this.hour);
        element.scrollIntoView({ behavior: "smooth" });
      }, 1000);
    },
  },
  created() {
    // todo : make sure every instance uses 'initialValue' prop and '@input' emit
    if (this.initialValue) {
      let time = new Date(this.initialValue);
      if (time.getHours() >= 12 && time.getHours() !== 0) {
        this.selectPeriod("PM");
        this.selectHour(time.getHours() - 12);
      } else {
        this.selectPeriod("AM");
        this.selectHour(time.getHours());
      }
      this.selectMinute(time.getMinutes());
      this.initialized = true;
    }
    // todo : find a way to make the ids unique across the entire document
  },
  mounted() {
    this.initializeScroll();
  },
  components: {},
  props: ["initialValue", "processing", "heading"],
  emits: ["input"],
};
</script>
<style scoped>
@media screen {
  #time-picker-wrapper {
    filter: drop-shadow(0px 4px 3px var(--secondaryColor));
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    box-sizing: border-box;
  }

  h5 {
    width: 100%;
  }

  #pickers {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .hour-picker,
  .minute-picker,
  .period-picker {
    background-color: var(--backgroundColor);
    filter: drop-shadow(0px 1px 3px var(--secondaryColor));
    border-radius: 10px;
    overflow: hidden;
    margin: 5px;
  }

  .hour-picker {
    position: relative;
    max-height: 160px;
  }

  .minute-picker {
    max-height: 160px;
  }

  .period-picker {
    max-height: 80px;
  }

  .scroll-container {
    scroll-snap-type: y mandatory;
    overflow: scroll;
    max-height: inherit;
  }

  h5 {
    scroll-snap-align: start;
    height: 40px;
    margin: 0;
    width: 40px;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .currentSelection {
    background-color: var(--contrastColor);
    color: var(--backgroundColor);
    border-radius: 10px;
  }
  @media (min-width: 800px) {
    h5 {
      width: 60px;
    }
  }
}
</style>
